export const errorRoutePaths = {
    malformedUrl: '/error/malformed-url',
};
